import BaseApi from './BaseApi';

import { PaginationParams } from 'models';

export class ProjectsApi extends BaseApi {
	constructor() {
		super('/projects');
	}

	getAll(params?: PaginationParams) {
		return this.httpClient.get({
			conditions: { version: 'v2', auth: true },
			config: { params },
		});
	}

	getOne(id: string) {
		return this.httpClient.get({
			url: `/${id}`,
			conditions: { version: 'v2', auth: true },
		});
	}
}
export const ProjectsService = new ProjectsApi();
